import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { accountIsMumber } from '@/store'

const useAccounIsMumber = () => {
  const navigate = useNavigate()
  const isMumber = useSelector(accountIsMumber)


  return null
}

export default useAccounIsMumber